import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Grid,
  Autocomplete,
  TextField,
} from '@mui/material';
// component
import Iconify from '../../../components/iconify';
import { DeleteUsers, GetUsersList } from '../../../components/services/httpServices';
import { Country } from 'country-state-city';
import { useState } from 'react';
import { useEffect } from 'react';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

ClientListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};
// const deleteUsers = (selectedUsersList) => {
//   DeleteUsers
// };

export default function ClientListToolbar({
  numSelected,
  filterName,
  onFilterName,
  selectedUsers,
  deleteUsers,
  setSelectedAgent,
}) {
 // console.log('SELECTED USERS:', numSelected);
//  console.log('SELECTED USERS:', selectedUsers);
  const [USERLIST, setUsersList] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const response = await GetUsersList();
      if (response !== null) {
        setUsersList(response);

        //console.log('UsersLit', response);
      }
    };
    fetchUsers();
  }, []);
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      <Grid width={200}>
        <Autocomplete
          size="small"
          options={USERLIST}
          getOptionLabel={(user) => user.name}
          renderInput={(params) => <TextField {...params} required label="Select Agent" variant="outlined" />}
          onChange={(event, user) => setSelectedAgent(user)}
        />
      </Grid>
    </StyledRoot>
  );
}
